import { createAsyncThunk } from '@reduxjs/toolkit'
import axiosInstance from 'axiosInstance'
import { displayMultipleNotifications } from 'utils/notificationsUtils'

// get notifications list
export const get_notifications_list = createAsyncThunk(
  'notificationsWidget/get_notifications_list',
  async ({ payload, showNotification }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(
        `v1/profile/notification-center/list?page=${payload.page}&pageSize=${payload.pageSize}&filter=${payload.filterType}`
      )
      if (response.status === 0) {
        return { response: response.data }
      }
      if (response.status === 1) {
        displayMultipleNotifications(response.data, showNotification)
      }
    } catch (error) {
      // Handle errors and rejection
      return rejectWithValue(error.response ? error.response.data : error.message)
    }
  }
)

// update notification
export const update_notification = createAsyncThunk(
  'notificationsWidget/update_notification',
  async ({ payload, showNotification, closeNotificationWidget }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(`v1/profile/notification-center/update`, payload)
      if (response.status === 0) {
        closeNotificationWidget()
        return { requestPayload: payload, response: response.data }
      }
      if (response.status === 1) {
        displayMultipleNotifications(response.data, showNotification)
      }
    } catch (error) {
      // Handle errors and rejection
      return rejectWithValue(error.response ? error.response.data : error.message)
    }
  }
)
